// Карточки направлений: главная сайта и первый экран Mini App (Иван, 26.10.2026: «там нельзя
// как в вебе делать?»). Миры и цены — с сервера.
import type { Catalog, Direction } from "../api/types";

export type Door = {
  direction: Direction;
  title: string;
  // Размер строкой под названием; у миниатюры он в метке на картинке.
  size?: string;
  text: string;
  tag: string;
  image: string;
  imageAlt: string;
  imagePosition: string;
};

function worldsText(catalog: Catalog | undefined): string {
  const worldCount = catalog?.miniature.worlds.length ?? 1;
  if (worldCount <= 1) {
    return "Раса и класс из каталога";
  }
  return `${worldCount} ${worldCount < 5 ? "мира" : "миров"}: раса, класс, типаж`;
}

export function doorsFor(catalog: Catalog | undefined): Door[] {
  return [
    {
      direction: "miniature",
      title: "Миниатюра для игры",
      text: worldsText(catalog),
      tag: "рост 40 мм · Ø 25 мм",
      // Серая миниатюра рядом с игральными кубиками: размер виден сразу, не по другим миниатюрам,
      // чей размер неизвестен (Иван, 01.11.2026). Картинка — Codex, work/codex/home_scale.
      image: "/showcase/mini_dice.jpg",
      imageAlt: "Серая миниатюра рядом с игральными кубиками",
      imagePosition: "55% 50%",
    },
    {
      direction: "gift",
      title: "Фигурка в любом образе",
      size: "10 или 15 см",
      text: "Пират, рыцарь, повар — опиши словами",
      tag: "себе или в подарок",
      // Пират на полке с книгами (Иван, 01.11.2026: «пират был лучше»).
      image: "/showcase/gift_shelf.jpg",
      imageAlt: "Фигурка пирата на книжной полке",
      imagePosition: "48% 40%",
    },
  ];
}
